"use client";

import { lazy } from "react";
import type { ToolUIRegistry } from "../../tool-renderer";

/** Views for the Concur attendee tools (search + attached-to-expense). */
export const concurAttendeeToolRegistry = {
  concurSearchAttendees: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./attendee-views").then(({ ConcurSearchAttendeesToolView }) => ({
        default: ConcurSearchAttendeesToolView,
      }))
    ),
  },
  concurGetExpenseAttendees: {
    kind: "standalone",
    category: "research",
    view: lazy(() =>
      import("./attendee-views").then(
        ({ ConcurGetExpenseAttendeesToolView }) => ({
          default: ConcurGetExpenseAttendeesToolView,
        })
      )
    ),
  },
} satisfies ToolUIRegistry;
